import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import TemplateFactory from "../Templates/TemplateFactory";
import PageAPIClient from "../../api/clients/page";
import Loading from "../Components/Loading";

export default function CustomPage({ slug }) {
  // router
  const router = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const pageSlug = (router && router.slug) || slug;
  // state
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(null);
  const [titleArea, setTitleArea] = useState(null);

  useEffect(() => {
    let allowedToLoad = true;
    // reset state when page slug changes
    setPage(null);
    setTitleArea(null);

    // check if a hero module is in-use
    const hasHero = (sections) => {
      if (!Array.isArray(sections) || sections.length === 0) return false;
      return sections.some(
        (section) =>
          section &&
          ("hero" === section.section_name ||
            "qip_hero" === section.section_name)
      );
    };

    const load = async () => {
      setIsLoading(true);
      try {
        const API = new PageAPIClient();
        const isHomePage = "/" === pageSlug;
        const response = isHomePage
          ? await API.getFrontPage()
          : await API.getPageBySlug(pageSlug);

        if (true === response.success && response.page) {
          const page = response.page;

          if (!isHomePage && (page.is_front_page || "home" === pageSlug)) {
            navigate("/", { replace: true });
            return;
          }

          // set page state
          setPage(page);
          const _sections = page.sections;
          // set title area state (if no 'hero' module exists...)
          if (!hasHero(_sections)) {
            setTitleArea({
              title: page.title || null,
              image: page.featured_image?.large
                ? page.featured_image?.large[0]
                : null,
              breadcrumbs: [
                {
                  title: "Primary Category",
                  url: "#",
                },
                {
                  title: "Secondary Category",
                  url: "#",
                },
              ],
            });
          } else {
            setTitleArea(null);
          }
        } else {
          setTitleArea({
            title: "Oops..",
            breadcrumbs: [
              {
                title: "Go Back Home",
                url: "/",
              },
            ],
          });
          setPage({ content: response.message });
        }
      } catch (error) {
        console.error(error);
        setTitleArea(null);
      }
      setIsLoading(false);
    };

    location &&
      "_error" !== location.pathname &&
      allowedToLoad &&
      Boolean(pageSlug) &&
      load();

    return () => {
      allowedToLoad = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSlug]);

  if (!isLoading && !page) return null;

  return isLoading && !page ? (
    <Loading inclIcon={true} />
  ) : (
    <TemplateFactory
      title={titleArea}
      content={page.content}
      template={page.template}
      modules={page.sections}
      sidebarModules={page.sidebar}
      footerModules={page.footer}
    />
  );
}
